module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-table', {
    attrs: {
      "data-api": this.api.whiteList,
      "viewable": false,
      "keyField": "id"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "编号",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mac",
      "label": "mac地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "loginCount",
      "label": "登录次数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vip",
      "label": "是否VIP"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.vip) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "vipType",
      "label": "VIP类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.vipType == 1 ? "试播VIP" : scope.row.vipType == 2 ? "付费VIP" : "非VIP") + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expireDate",
      "label": "到期时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "enabled",
      "label": "启用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n        " + _vm._s(scope.row.enabled) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createDate",
      "label": "添加时间"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a35e5006","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/whiteList/List.vue
// module id = 1189
// module chunks = 2